var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GenericReport',{ref:"report",staticClass:"clean-list",attrs:{"hide-header":"","orientation":"horizontal","reportSpec":_vm.reportSpec,"adapterSpec":_vm.adapterSpec,"fetcher":_vm.fetchData},on:{"rowClicked":_vm.showRowDetails}})}
var staticRenderFns = []

export { render, staticRenderFns }